import React from 'react';
import * as valid from 'utils/validate';
import { renderKBInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { KBInput,
KBFormError,
KBButton } from
'components';

var PassWord = class extends React.Component {render()

  {
    const {
      fields: { current_password, password, password_confirmation },
      error,
      submitting,
      handleSubmit,
      updateUserPasswordForm } =
    this.props;

    return (
      <section className="nav-section-container  f-right">
        <header className="nav-header clear-fix">
          <div className="nav-section-header-title">
            <span>账号密码</span>
          </div>
        </header>
        <div className="title-box">
          <div className="kb-title">
            <span className="color-six">登录密码</span>
          </div>
        </div>
        <form onSubmit={handleSubmit(updateUserPasswordForm)}>
          <div className="kb-form-container">
            <KBFormError err={error} />
            <div className="kb-row">
              <Field name="current_password" component={renderKBInput}
              title="当前密码"

              type="password"
              className="kb-form-group kb-form-c18 kb-form-alone o-hidden" />

            </div>
            <div className="kb-row">
              <Field name="password" component={renderKBInput}
              title="新密码"

              type="password"
              className="kb-form-group kb-form-c18 kb-form-alone o-hidden" />

            </div>
            <div className="kb-row">
              <Field name="password_confirmation" component={renderKBInput}
              title="确认密码"

              type="password"
              className="kb-form-group kb-form-c18 kb-form-alone o-hidden" />

            </div>
            <div className="kb-row">
              <KBButton
              className="certain-btn"
              type="submit"
              submitting={submitting}>

                确定
              </KBButton>
            </div>
          </div>
        </form>
      </section>);

  }};


const validate = values => {
  const errors = {};

  if (valid.required(values.current_password)) {
    errors.current_password = '请输入当前密码';
  }

  if (valid.required(values.password)) {
    errors.password = '请输入新密码';
  }

  if (valid.required(values.password_confirmation)) {
    errors.password_confirmation = '请输入确认密码';
  }

  if (values.current_password == values.password) {
    errors.password = '新密码不能与当前密码相同';
  }

  if (values.password_confirmation != values.password) {
    errors.password_confirmation = '请输入两次密码输入不一致';
  }

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "current_password",
  "password",
  "password_confirmation"
];

const formConfig = {
  form: 'PassWordForm',
  touchOnBlur: false,
  validate: validate };


export default reduxForm(formConfig)(withReduxFormFieldProps('PassWordForm', LEGACY_FORM_FIELDS)(PassWord));
